<template>
  <headers />

  <div class="info" v-if="set.istime==true">
    <div style="height: 50px">
      <p style="float: left; font-weight: bold; font-size: 16px">
        选床温馨提示：
      </p>
      <p style="float: left; text-align: left">
        {{ inradios }}
      </p>

      <el-button
        class="onSubmit"
        v-if="ruleForm.istrue && !ruleForm.MainDate"
        @click="onSubmit(ruleForm.datas)"
        >提 交</el-button
      >
      <el-button
        class="onSubmit"
        v-if="!ruleForm.istrue && !ruleForm.MainDate"
        @click="onview()"
        >查看住宿确认表</el-button
      >
      <el-button class="onSubmit" v-if="ruleForm.MainDate"
        >已过选床时间</el-button
      >
    </div>

    <hr />
    <!-- <el-divider content-position="left"></el-divider> -->

    <el-card class="box-card" v-for="(item, i) in ruleForm.datas" :key="i">
      <template #header>
        <div class="card-header">
          <span
            >{{ item.building_Name }}-{{ item.house_Name }}
            <el-tag size="mini"
              >窗户朝向：朝{{ item.house_direction }}</el-tag
            ></span
          >
          <!-- <el-button class="button" type="text" @click="handleClose(item.house_Name)">看全景</el-button>        -->
        </div>
      </template>
      <div class="text item" v-for="(items, j) in item.zsfpItem" :key="j">
        <el-div
          class="radiodiv"
          v-if="items.student_IdNumber == null || items.student_IdNumber == ''"
          v-model="radio"
          :label="items.cw_ID"
          border
          :class="{ radiodivselect: items.cw_ID == active }"
          @click="
            changeRadio(
              item.building_Name +
                '-' +
                item.house_Name +
                '-' +
                items.cw_Name +
                '床' +
                items.cw_type +
                '，' +
                items.cw_price +
                '元/学年',
              items.cw_ID
            )
          "
          >{{ items.cw_Name + "床" }} {{ items.cw_type }} ({{
            items.cw_price
          }}元/年)
          <br />
          <p class="kongchuang">空床</p>
        </el-div>
        <el-div
          class="radiodivdis"
          disabled
          v-if="items.student_IdNumber != null"
          v-model="radio"
          :label="items.cw_ID"
          border
        >
          {{ items.cw_Name + "床" }} {{ items.cw_type }} ({{
            items.cw_price
          }}元/年)
          <br />
          <span v-if="items.student_Name != null" class="ratiospan">
            <el-tag size="small" type="success">{{
              items.student_Name
            }}</el-tag>
            <el-tag size="mini">{{ items.student_mz }}</el-tag>
            <el-tag
              type="danger"
              v-if="
                (items.student_Habits != '') & (items.student_Habits != null)
              "
              size="mini"
              >{{ items.student_Habits }}</el-tag
            >
          </span>
        </el-div>
      </div>
    </el-card>
  </div>
  <div class="info" v-if="set.istime!=true">
    <p v-html="set.info" style="white-space: pre-wrap;font-size:18px;text-align: left;padding: 0 30%;"></p>
  </div>
</template>

<style lang="scss" scoped>
.el-radio.is-bordered {
  height: 60px;
  line-height: 20px;
}
.kongchuang{
  text-align: center;
  font-size: 18px;
  margin: 10px 0;
}
.radiodiv {
  height: 60px;
  line-height: 25px;
  border: 1px solid #059490;
  border-radius: 6px;
  display: block;
  cursor: pointer;
}

.radiodivselect {
  height: 60px;
  line-height: 25px;
  border: 1px solid #000;
  border-radius: 6px;
  display: block;
  cursor: pointer;
  background: #409eff;
  color: #fff;
}
.radiodiv:hover {
  height: 60px;
  line-height: 25px;
  border: 1px solid #409eff;
  border-radius: 6px;
  display: block;
  cursor: pointer;
  background: #409eff;
}
.radiodivdis {
  height: 60px;
  line-height: 25px;
  border: 1px solid #909399;
  border-radius: 6px;
  display: block;
  background: #c0c4cc;
}
.el-button-cuc {
  background-image: none;
  background-color: #059490;
  width: calc(30% - 40px);
  line-height: 1;
  padding: 10px 0;
  cursor: pointer;
  border: 1px solid #04726f;
  font-family: "Microsoft YaHei";
  font-size: 16px;
  height: 50px;
  line-height: 25px;
  border-radius: 6px;
  margin: 8px 0 0 21px;
  color: #fff;
  text-align: center;
  position: relative;
  box-sizing: border-box;
}
.ratiospan {
  color: black;
}
.onSubmit,
.onSubmit-cuc:hover,
.onSubmit-cuc:focus {
  padding: 10px 0;
  float: right;
  margin: 8px 0 0 21px;
  color: #fff;
  text-align: center;
  background-color: #059490;
  height: 30px;
  line-height: 15px;
  width: 140px;
}
.onInfo {
  position: absolute;
  right: 24%;
  top: 120px;
}
.info {
  max-width: 1180px;
  margin: 0 auto;
}
.el-radio {
  width: 100%;
  text-align: left;
}
.item {
  padding: 2px 0;
  width: 100%;
}
.box-card {
  width: 280px;
  float: left;
  margin: 15px 6px;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button {
  margin-left: 30px;
  min-height: auto;
}

.image {
  width: 100%;
  display: block;
}
</style>

<script>
import { defineComponent } from "vue";
import { reactive } from "vue";
import { ref } from "vue";
import Route from "../router/index";
import headers from "../views/Home.vue";
import { GetHouseList } from "../http/api.ts";
import { selecthose } from "../http/api.ts";
import { SaveSelectHouse } from "../http/api.ts";
import { getTime } from "../http/api.ts";
import { ElMessage } from "element-plus";
import { ElMessageBox } from "element-plus";

import { GetWebSiteSet } from "@/http/api";

let inradio = "";
let cwID = "";

export default defineComponent({
  name: "house",
  components: {
    headers,
  },
  setup() {
    let ruleForm = reactive({
      datas: [],
      MainDate: false,
      istrue: false,
      mz: "",
    });
    let set =reactive({
      info:'',
      istime:false
    });
    let dataFun = async () => {
      await getTime().then((res) => {
        set.istime=res.datas;
        
        });
        
      await GetWebSiteSet().then((res) => {
          set.info=res.datas.openDesc;
      });
      if(!set.istime){
          return false;
        }
      await GetHouseList().then((res) => {
        ruleForm.datas = reactive(res.datas.zsfp);
        ruleForm.MainDate = reactive(res.datas.ZsfpMainDate);
        ruleForm.mz = reactive(res.datas.mz);
      });
      await selecthose().then((res) => {
        if (res.code == 200) {
          ruleForm.istrue = true;
        } else {
          ruleForm.istrue = false;
        }
      });
      

    };

    dataFun();
    const radio = ref("1");
    const inradios = ref("选床信息提交后不能修改。");
    return {
      ruleForm,
      radio,
      inradios,
      dialogVisible: false,
      active: 0,set
    };
  },
  methods: {
    goBack() {
      console.log("go back");
    },
    onSubmit() {
      if (inradio.length == 0) {
        ElMessage.warning({message:"请选择您的床位！",offset: 300});
        return false;
      }

      getTime().then((res) => {
        if (!res.datas) {
          ElMessage.error({message:res.msg,offset: 300});
        } else {
          ElMessageBox.confirm(
            "您选择的是[" + inradio + "], 是否继续?",
            "提示",
            {
              confirmButtonText: "确认提交",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              const loading = this.$loading({
                lock: true,
                text: "程序正在处理，请耐心等待...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
              });
              const housepo = {
                cw_Id: cwID,
                source: "PC",
                mz: this.ruleForm.mz,
              };
              SaveSelectHouse(housepo).then((res) => {
                if (res.code == 200) {
                  this.$alert(
                    "您已完成选床操作，请认真阅读《中国传媒大学学生公寓住宿协议书》，打印《中国传媒大学学生公寓住宿信息确认表》和《国传媒大学学生公寓住宿协议书》，本人签字确认并粘贴一寸照片，办理入住手续时交于公寓管理人员。",
                    "提示",
                    {
                      dangerouslyUseHTMLString: true,
                      confirmButtonText: "确定",
                      callback: () => {
                        Route.push("/view?tmsite=" + Math.random());
                      },
                    }
                  );
                } else if (res.code == 201) {
                  this.$message({
                    message: res.msg,
                    type: "error",
                    offset: 300,
                    duration: 5000,
                  });
                } else if (res.code == 202) {
                  this.$alert(res.msg, {
                    dangerouslyUseHTMLString: true,
                  });
                  setTimeout(function () {
                    window.location.reload();
                  }, 2000);
                } else if (res.code == 1001) {
                  this.$alert("没有抢到，请重新提交床位！", {
                    dangerouslyUseHTMLString: true,
                  });
                  setTimeout(function () {
                    window.location.reload();
                  }, 2000);
                }

                loading.close();
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        }
      });
    },
    changeRadio(event, cw_ID) {
      inradio = event;
      cwID = cw_ID;
      this.active = cw_ID;
      this.inradios = "您已选择：  " + event + " 。选床信息提交后不能修改。";
    },
    handleClose() {
      window.open("/vr", "_blank");
    },
    onview() {
      Route.push("/view");
    },
  },
});
</script>
